import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addyf, updyf } from "@/api/financial/consumptionDetails";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        special_product_id: "",
        ad_channel: '',
        ad_placement: '',
        f_pri_name: "",
        f_pri: "",
        token: ""
      },
      rules: {
        special_product_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        f_pri_name: [{
          required: true,
          message: "请输入媒体名称",
          trigger: "blur"
        }],
        f_pri: [{
          required: true,
          message: "请输入媒体",
          trigger: "blur"
        }],
        token: [{
          required: true,
          message: "请输入token",
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px",
      interdits: false,
      InitializeOrNot: false,
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, ds, k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.interdits = data ? true : false;

                if (!data) {
                  _context.next = 12;
                  break;
                }

                datas = {
                  game_id: _this.rawData.game_id,
                  special_product_id: data.product_id
                };
                _context.next = 6;
                return _this.getAdvPlarform(datas);

              case 6:
                _this.searchData.ad_channel = data.ad_channel;
                _context.next = 9;
                return _this.advChannelchange(data.ad_channel);

              case 9:
                ds = {};

                for (k in _this.searchData) {
                  ds[k] = data[k] ? data[k] : '';
                }

                _this.searchData = _this.processingData(_objectSpread(_objectSpread({}, ds), datas));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.searchData.id ? updyf : addyf;
          req(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              if (_this2.searchData.id) {
                _this2.$emit("refreshDataList");
              }

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id,
        ad_channel: '',
        ad_placement: '',
        f_pri_name: "",
        f_pri: "",
        token: ""
      };
      this.advLocation = [];

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.$refs.ruleForm.resetFields();
    }
  }
};